import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import LocationAutosuggest from '../../../site/location-autosuggest';
class LocationField extends Component {
    constructor() {
        super(...arguments);
        this.handleAddressSelect = (item) => this.props.onAddressSelect(item);
    }
    render() {
        const { name, address, error, t } = this.props;
        const className = classnames({
            'address-field-wrapper': true,
            error,
        });
        return (React.createElement("div", { className: className },
            this.props.showLabel && (React.createElement("label", { className: "block mb-1 form-label" }, t('ADDRESS'))),
            React.createElement(LocationAutosuggest, { key: address, id: this.props.locationAddressId, name: name, address: address, value: address, suggestions: [{ name: name, address: address }], callbackSelectedItem: this.handleAddressSelect })));
    }
}
LocationField.propTypes = {
    address: PropTypes.string,
    name: PropTypes.string,
    showLabel: PropTypes.bool,
    onAddressSelect: PropTypes.func.isRequired,
    error: PropTypes.bool,
};
LocationField.defaultProps = {
    name: '',
    address: '',
    showLabel: true,
    error: false,
};
export default withTranslation()(LocationField);
